export class AbstractDisplayComponent {
    public init() {
        //
    }

    public destroy() {
        //
    }
}
